<template>
  <el-form ref="formRef" :model="creativeForm" :rules="formRules" @submit.native.prevent class="creative-config-form" label-width="130px">
    <Divider title="创意形式"></Divider>

    <el-form-item label="创意名称" prop="dynamic_creative_name">
      <el-input
        v-model="creativeForm.dynamic_creative_name"
        placeholder="请输入创意名称，2-30个字符"
        maxlength="30"
        show-word-limit
        clearable
      />
    </el-form-item>

    <el-form-item label="描述" prop="description_component_options">
      <DescriptionList v-model="creativeForm.description_component_options" />
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref } from 'vue'
import Divider from '@/views/create/bytedance/components/layout/title-divider.vue'
import DescriptionList from './description-list.vue'

// 表单数据
const creativeForm = ref({
  dynamic_creative_name: '',
  description_component_options: [{ value: '' }]
})

// 表单验证规则
const formRules = {
  dynamic_creative_name: [
    { required: true, message: '请输入创意名称', trigger: 'blur' },
    { min: 2, max: 30, message: '创意名称长度在2-30个字符', trigger: 'blur' }
  ],
  description_component_options: [
    {
      validator: (rule, value, callback) => {
        if (!value || value.length === 0) {
          callback(new Error('至少需要一条描述'))
          return
        }

        const hasEmptyDesc = value.some((item) => !item.value || item.value.trim() === '')
        if (hasEmptyDesc) {
          callback(new Error('描述内容不能为空'))
          return
        }

        const hasInvalidLength = value.some((item) => item.value.length < 5 || item.value.length > 80)
        if (hasInvalidLength) {
          callback(new Error('每条描述长度需在5-80个字符'))
          return
        }

        callback()
      },
      trigger: 'blur'
    }
  ]
}

// 表单引用
const formRef = ref(null)

// 表单验证
const validate = () => {
  return new Promise((resolve, reject) => {
    formRef.value.validate((valid) => {
      if (valid) {
        resolve(creativeForm.value)
      } else {
        reject(new Error('表单验证失败'))
      }
    })
  })
}

// 获取表单数据
const getForm = () => {
  return creativeForm.value
}

// 暴露方法给父组件
// eslint-disable-next-line
defineExpose({
  validate,
  getForm,
  setForm(form) {
    creativeForm.value = { ...form }
  }
})
</script>

<style lang="scss" scoped></style>
